<template>
  <div class="text-center">
    <v-form
      ref="form"
      v-model="valid"
    >
      <v-text-field
        label="ユーザー名"
        v-model="name"
        :rules="nameRules"
        required
      />
  
      <v-btn
        :disabled="!valid"
        color="success"
        @click="save"
      >
        保存
      </v-btn>
  
    </v-form>

    <v-snackbar
      color="success"
      v-model="saved"
      :timeout="4000"
    >
      プロフィールを更新しました
    </v-snackbar>

    <v-snackbar
      color="error"
      v-model="failed"
      :timeout="6000"
    >
      エラー：{{ failed_message }}
    </v-snackbar>
  </div>
</template>

<script>
// eslint-disable-next-line

export default {
  data: () => ({
    valid: false,
    //name: "",
    newName: "",
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length < 16) || 'Name must be less than 16 characters',
    ],
    saved: false,
    failed: false,
    failed_message: "",
  }),
  computed: {
    name: {
      get: function() {
        return this.$store.state.user.name;
      },
      set: function(v) {
        this.newName = v
      },
    },
  },
  methods: {
    save: function() {
      this.$store.dispatch('setUser', { name: this.newName || this.name }).then(() => {
        this.saved = true;
      }).catch(e => {
        this.failed = true;
        this.failed_message = e.message;
      });
    }
  },
  created() {
    //this.name = this.$store.state.user.name;
  }
};
</script>
